export const SHARED_LISTS_YES_NO_LIST = "SHARED_LISTS_YES_NO_LIST";
export const SHARED_LISTS_LANGUAGE_CODE_LIST = "SHARED_LISTS_LANGUAGE_CODE_LIST";
